<template>
  <div class="cost-sharing">
    <div class="flex align-center" style="padding: 8px 0 4px 0">
      <gj-breadcrumb :list="breadcrumbList" @backHandle="pageBack"></gj-breadcrumb>
    </div>

    <div class="main">
      <el-form
          slot="content"
          inline
          :model="form"
          ref="form"
      >
        <el-row>
          <div class="main-header flex justify-between">
            <div>
              <el-form-item class="noBottom">
                <gj-button type="primary" @click="importCost">导入分摊</gj-button>
              </el-form-item>

              <el-form-item prop="countryData" class="noBottom">
                <gj-country-server-select v-model="form.countryData" @input="handleFetchCost"/>
              </el-form-item>

              <el-form-item prop="feeName" class="noBottom">
                <gj-select
                    v-model="form.feeName"
                    placeholder="全部费用"
                    :options="feeNameOption"
                    @input="handleFetchCost"
                >
                </gj-select>
              </el-form-item>

              <el-form-item class="noBottom">
                <gj-date-picker
                    v-model="form.feeShareMonth"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    type="month"
                    :clearable="false"
                    @change="handleFetchCost"
                >
                </gj-date-picker>
              </el-form-item>

            </div>

            <gj-button type="text" v-if="$permission('financeAndCost:edit')" @click="$router.push({path: '/setting/argument?activeTab=financeCost'})">设置分摊方式
            </gj-button>

          </div>

        </el-row>

<!--        <el-row>-->
<!--          <div class="main-tips flex align-center">-->
<!--            <i class="el-icon-warning colorBlue"></i>-->
<!--            <span class="size12 color666">同一店铺国家下，同一个费用项需要一次性分摊完；手动分摊后数据将会在1小时内自动重算更新。</span>-->
<!--          </div>-->
<!--        </el-row>-->

        <gj-table
            :data="data"
            :columns="columns"
            :loading="loading"
            :highlightHoverRow="false"
            :adapt-height="true"
            border="full"
            :structure-config="{type: 'ParentChild', children: 'fee', spanType: 'row', parentSpan: [0,1,2,7]}"
        >

          <template v-slot:index="{ row }">
            {{ row.index + 1 }}
          </template>

          <template v-slot:feeAmount="{ row }">
            <span>{{ row.currencySymbol }}{{ row.feeAmount | defaultShow }}</span>
          </template>

          <template v-slot:shareDateRange="{row}">
            <span v-if="row.feeDateStart">{{ row.feeDateStart }}至{{ row.feeDateEnd }}</span>
            <span v-else>-</span>
          </template>

          <template v-slot:asins="{row}">
            <el-tooltip popper-class="tooltip" placement="top-end"
                        v-if="row.asins.length>0">
              <div slot="content" class="tip-box flex">
                <span class="size12" style="flex: 1;" v-for="(i,index) in row.asins" :key="i+index">
                  {{i+(index>row.asins.length-2?'':'，')}}
                </span>
              </div>
              <gj-button type="text" style="color: #333">
                {{ row.asins.length }}
                <i class="el-icon-arrow-down"></i>
              </gj-button>
            </el-tooltip>
            <span v-else>-</span>
          </template>

          <template v-slot:op="{ row }">
            <gj-button type="text" @click="handleShowAverageDetail(row)" v-if="row.asinDetails.length===0">设置
            </gj-button>
            <gj-button type="text" @click="handleShowAverageDetail(row)" v-else>详情</gj-button>
          </template>
        </gj-table>

      </el-form>

    </div>
  </div>
</template>

<script>
import {
  getFeeAllOptions,
  postFeeShareList
} from '@/api/finance'

import {
  formValidatorMixin,
  responseMixin
} from "@/minxins";
import {mapGetters} from "vuex";
import {debounce} from 'lodash'
import {startOfMonth, endOfMonth, format, subMonths} from 'date-fns'

import CostAverageDetailModal from './modal/cost-average-detail-modal'
import CostCenterImport from "@/views/modules/finance/cost-center/cost-center-import";
//导入弹窗组件
import ImportAverageExpenses from './modal/import-average-expenses'
//分摊弹窗组件
import CostSharingDetailsModal from './modal/cost-sharing-details-modal'


export default {
  name: "cost-sharing",
  props: {
    dateValue: {
      type: [Date, String]
    },
  },
  mixins: [formValidatorMixin, responseMixin],
  data() {
    return {
      breadcrumbList:[
        {
          name: '利润报表', handle: () => {
            this.$emit('pageBack')
          }
        },
        {
          name: '费用分摊', handle: () => {}
        }
      ],

      transferOrder: {},
      form: {
        countryData: {
          countryIds: [],
          marketIds: []
        },
        feeName: '',
        feeShareMonth: '',
      },
      data: [],
      columns: [
        {id: 'index', header: '序号', field: 'slot:index', width: '60px'},
        {
          id: 'marketId',
          header: '店铺/国家',
          field: 'option:marketId',
          minWidth: '120px',
          options: () => this.marketOption
        },
        {id: 'feeName', header: '费用名称', field: 'feeName', minWidth: '100px'},
        {id: 'desc', header: '描述', field: 'desc', minWidth: '300px',},
        {id: 'feeAmount', header: '费用金额', field: 'slot:feeAmount', minWidth: '100px'},
        {id: 'shareDateRange', header: '分摊日期', field: 'slot:shareDateRange', minWidth: '200px'},
        {id: 'asins', header: '分摊ASIN', field: 'slot:asins', minWidth: '140px'},
        // {id: 'asins', header: 'slot:asinHeader', field: 'slot:asins', minWidth: '220px'},
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '100px'},
      ],
      tableData: [],
      feeNameOption: [],
      loading: false,
      disabledDate: (date) => {
        let dateValue = new Date(this.form.feeShareMonth)

        const startOfMonthDate = startOfMonth(dateValue)
        const endOfMonthDate = endOfMonth(dateValue)
        return date < startOfMonthDate || date > endOfMonthDate
      }
    }
  },
  mounted() {
    this.initForm();
    this.postFeeShareList();
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  methods: {
    pageBack() {
      this.$emit('pageBack')
    },
    importCost() {
      this.$gjCreate(ImportAverageExpenses, {
        on: {
          importSuccess: (data) => {
            this.updateItems(data);
          },
          importPartSuccess: (data) => {
            this.updateItems(data);
          }
        }
      })
    },
    updateItems(data) {
      this.postFeeShareList();
    },
    /**
     * 日期选择
     */
    handleDateChange(row) {
      row.shareBeginDate = row.shareDateRange[0] || ''
      row.shareEndDate = row.shareDateRange[1] || ''
    },
    /**
     * 分摊详情
     */
    handleShowAverageDetail(row) {
      let myRow = this._.cloneDeep(row);
      let country = this.marketOption.find(o => {
        return myRow.marketId == o.id
      })
      myRow.countryCode = country.countryCode;
      myRow.marketName = country.market;
      myRow.fee.forEach(i => {
        let sum = 0;
        i.asinDetails.forEach(m => {
          sum += m.shareMoneyTotal;
          m.currencySymbol = i.currencySymbol;
        })
        i.sum = Math.round(sum * 10000) / 10000;
        i.diff = sum - i.feeAmount;
        i.canSet = i.diff === 0 ? true : false;
        i.countryCode = country.countryCode;
        i.marketName = country.market;
      })
      //创建分摊面板，传递 月份和已提交的分摊列表
      this.$gjCreate(CostSharingDetailsModal, {
        props: {
          row: myRow,
          param: {
            countryId: myRow.countryCode,
            marketId: myRow.marketId,
            feeName: myRow.feeName,
            feeShareMonth: this.form.feeShareMonth,
          },
          form: {
            marketName: myRow.marketName
          }
        },
        on: {
          submit: () => {
            this.postFeeShareList();
          }
        }
      })
    },
    /**
     * 查询
     */
    handleFetchCost() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.postFeeShareList()
        }
      })
    },
    /**
     * 重置
     */
    handleRestForm() {
      this.form.countryData.countryIds = [];
      this.form.countryData.marketIds = [];
      this.form.feeName = ''
    },
    /**
     * 初始化form
     */
    initForm() {
      this.form.feeShareMonth = this.dateValue || format(subMonths(new Date(), 1), 'yyyy-MM')
      this.getFeeAllOptions()
    },
    /**
     * 查询费用分摊列表
     */
    postFeeShareList() {
      let {countryData, feeName = '', feeShareMonth = ''} = this.form
      let {countryIds = [], marketIds = []} = countryData
      let params = {
        countryIds,
        marketIds,
        feeName,
        feeShareMonth
      }
      this.loading = true
      postFeeShareList(params).then((res = []) => {
        res.forEach((i, index) => {
          i.index = index;
        })
        this.data = res;
      }).complete(() => this.loading = false)
    },
    /**
     * 获取费用名称下拉选项
     */
    getFeeAllOptions() {
      getFeeAllOptions().then((res = []) => this.feeNameOption = res)
    },
  }
}
</script>

<style scoped lang="scss">
.cost-sharing {
  background-color: #FFFFFF;
  .cost-sharing-breadcrumb {
    padding-left: 16px;
    width: 116px;
    align-items: center;
    justify-content: space-between;
  }

  .main {
    position: relative;
    height: 85%;
    background-color: #FFFFFF;
    //padding: 24px 16px 20px;
    margin-top: 12px;

    .main-header {
      padding-bottom: 12px;

      .noBottom {
        margin-bottom: 0;
      }
    }

    //.main-tips {
    //  height: 40px;
    //  background: #EFF3FF;
    //  border: 1px solid #BBCDF9;
    //  border-radius: 4px;
    //  padding: 0 20px;
    //  margin-bottom: 12px;
    //
    //  .el-icon-warning {
    //    font-size: 18px;
    //    margin-right: 4px;
    //  }
    //}



    .main-submit {
      width: 100%;
      position: absolute;
      bottom: 20px;
    }
  }
}
</style>
